import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();


// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');

const lerEvento = async () => {
    return new Promise( async (resolve, reject) => {
        const tema = localStorage.getItem('tema');
        const root = document.documentElement;
        try {
            const doc = await db.collection(ANO).doc('evento').get();
            
            if (doc.exists) {
                const evento = doc.data().nome;
                const status = localStorage.getItem('temaStatus');

                if (status !== 'off') {
                    if (!evento || evento === 'normal') {
                        if (tema !== 'light' && tema !== 'dark') {
                            localStorage.setItem('tema', 'light');                
                            root.style.setProperty('--two', '#072a4a');
                        } else {
                            root.style.setProperty('--two', '#072a4a');
                        }
                    } else if (evento === 'natal') {
                        await localStorage.setItem('tema', 'natal');
                        root.style.setProperty('--dark', '#226338');
                        root.style.setProperty('--two', '#BD3634');
                        root.style.setProperty('--tree', '#BD3634');
                        root.style.setProperty('--light', 'white');
                        root.style.setProperty('--imagem', 'https://cdn-icons-png.flaticon.com/512/744/744546.png');
                    } else if (evento === 'halloween') {
                        await localStorage.setItem('tema', 'halloween');
                        root.style.setProperty('--dark', '#361E5C');
                        root.style.setProperty('--two', '#F27F1B');
                        root.style.setProperty('--tree', '#F27F1B');
                        root.style.setProperty('--light', 'white');
                        root.style.setProperty('--imagem', 'https://cdn-icons-png.flaticon.com/512/3384/3384164.png');
                    }
                } else {
                    root.style.setProperty('--two', '#072a4a');
                }

                resolve(evento);
            } else {
                console.error('Documento de evento não encontrado.');
                return reject(null);
            }
        } catch (error) {
            console.error('Erro ao ler evento:', error);
            throw error;
            reject(error);
        }
    });
};

export { lerEvento };